export default function ({ $auth, $axios }) {
    if (!$auth.loggedIn) return
    window.gonative_onesignal_info = function (info) {
        $axios.$put("api/users/" + $auth.user.id, {
            one_signal_id: info.oneSignalUserId,
        })
    }
}
